// extracted by mini-css-extract-plugin
export default {"isPacc":"navTopRight_isPacc__LNUB9"};